export const renderPdf = (fileUrl) => (
  <div className="document-container">
    <embed
      src={fileUrl}
      type="application/pdf"
      className="document-embed"
      onError={(e) => console.error("Error loading PDF:", e)}
    />
  </div>
);

export const renderDocx = (fileUrl) => {
  // URL-encode the fileUrl for use in Google Docs Viewer
  const encodedUrl = encodeURIComponent(fileUrl);
  const googleDocsViewerURL = `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
  return (
    <div className="document-container">
      <iframe
        src={googleDocsViewerURL}
        className="document-iframe"
        title="DOCX Viewer"
        onError={(e) => {
          console.error("Error loading DOCX:", e);
          return (
            <p className="error-text">
              Error loading DOCX document. Please ensure the file is accessible.
            </p>
          );
        }}
      />
    </div>
  );
};

export const renderImage = (fileUrl) => (
  <div className="document-container">
    <img
      src={fileUrl}
      alt="Attached Image"
      className="document-image"
      onError={(e) => console.error("Error loading Image:", e)}
    />
  </div>
);
